import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Stack,
  Divider,
} from "@mui/material";
import { Phone, Email, Language, LocationOn } from "@mui/icons-material";

const Resume40 = ({ color = "#323b4c" }) => {
  // Update: Heading-kum 'color' prop use panni iruken
  const SectionTitle = ({ title }) => (
    <Box sx={{ mb: 2, mt: 3 }}>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 800,
          fontSize: "14px",
          color: color, // Header color heading-kum apply aagum
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        {title}
      </Typography>
      <Divider sx={{ bgcolor: color, height: "1.5px", mt: 0.5, opacity: 0.6 }} />
    </Box>
  );

  return (
    <Box
      sx={{
        width: "210mm",
        minHeight: "297mm",
        mx: "auto",
        bgcolor: "#fff",
        boxShadow: "0 0 15px rgba(0,0,0,.1)",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* HEADER SECTION */}
      <Box sx={{ bgcolor: color, color: "#fff", p: 5, pt: 6, pb: 4 }}>
        <Typography variant="h3" fontWeight={900} sx={{ letterSpacing: 2, mb: 1 }}>
          OLIVIA WILSON
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 400, letterSpacing: 1, opacity: 0.9 }}>
          Marketing Manager
        </Typography>
      </Box>

      {/* CONTACT BAR */}
      <Box sx={{ p: 2, px: 5, borderBottom: "1px solid #eee" }}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Phone sx={{ fontSize: 14, color: color }} />
              <Typography fontSize="10px">+123-456-7890</Typography>
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Email sx={{ fontSize: 14, color: color }} />
              <Typography fontSize="10px">hello@reallygreatsite.com</Typography>
            </Stack>
          </Grid>
          <Grid item xs={2}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Language sx={{ fontSize: 14, color: color }} />
              <Typography fontSize="10px">reallygreatsite.com</Typography>
            </Stack>
          </Grid>
          <Grid item xs={3}>
            <Stack direction="row" alignItems="center" gap={1}>
              <LocationOn sx={{ fontSize: 14, color: color }} />
              <Typography fontSize="10px">123 Anywhere St., Any City</Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>

      {/* MAIN BODY */}
      <Grid container>
        <Grid item  sx={{ p: 5, pt: 2,width:"530px" }}>
          <SectionTitle title="Experience" />
          <Stack spacing={3}>
            {[1, 2, 3, 4].map((item, index) => (
              <Box key={index}>
                <Grid container justifyContent="space-between">
                  <Typography fontWeight={700} fontSize="12px" color={color}>Marketing Manager</Typography>
                  <Typography fontSize="10px" color="gray">Aug 2018 - present</Typography>
                </Grid>
                <Typography fontSize="11px" fontWeight={600} sx={{ mb: 0.5 }}>Arowwai Industries</Typography>
                <Typography fontSize="10px" color="#555" textAlign="justify">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan.
                </Typography>
              </Box>
            ))}
          </Stack>

          <SectionTitle title="Skills" />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack spacing={0.5}>
                <Typography fontSize="11px">• Management Skills</Typography>
                <Typography fontSize="11px">• Creativity</Typography>
                <Typography fontSize="11px">• Digital Marketing</Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack spacing={0.5}>
                <Typography fontSize="11px">• Negotiation</Typography>
                <Typography fontSize="11px">• Critical Thinking</Typography>
                <Typography fontSize="11px">• Leadership</Typography>
              </Stack>
            </Grid>
          </Grid>

          <SectionTitle title="References" />
          <Grid container spacing={4}>
            {["Harumi Kobayashi", "Bailey Dupont"].map((name) => (
              <Grid item xs={6} key={name}>
                <Typography fontWeight={700} fontSize="12px" color={color}>{name}</Typography>
                <Typography fontSize="10px" color="gray">Wardiere Inc. / CEO</Typography>
                <Typography fontSize="10px">Phone: 123-456-7890</Typography>
                <Typography fontSize="10px">Email: hello@reallygreatsite.com</Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item  sx={{ p: 4, pt: 2, bgcolor: "#fafafa", minHeight: "230mm",width:"250px" }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 4, mt: 2 }}>
            <Avatar
              src="https://via.placeholder.com/200"
              sx={{ width: 150, height: 150, border: `4px solid ${color}`, boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}
            />
          </Box>

          <SectionTitle title="About Me" />
          <Typography fontSize="11px" color="#555" textAlign="justify" mb={3}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan.
          </Typography>

          <SectionTitle title="Education" />
          <Stack spacing={2} mb={3}>
            {[1, 2, 3].map((i) => (
              <Box key={i}>
                <Typography fontWeight={700} fontSize="12px" color={color}>Wardiere University</Typography>
                <Typography fontSize="11px">Bachelor of Business Management</Typography>
                <Typography fontSize="10px" color="gray">2020 - 2023</Typography>
              </Box>
            ))}
          </Stack>

          <SectionTitle title="Language" />
          <Stack spacing={0.5} mb={3}>
            <Typography fontSize="11px">English</Typography>
            <Typography fontSize="11px">Spain</Typography>
            <Typography fontSize="11px">Arabic</Typography>
          </Stack>

          <SectionTitle title="Awards" />
          <Typography fontSize="10px" fontWeight={700} color={color}>Oct 2019 | Ingoude Company</Typography>
          <Typography fontSize="11px">The Best Employee of the Year</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume40;
export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#084c34", label: "Forest Green" },
    { value: "#1a2a6c", label: "Navy Blue" },
    { value: "#b22222", label: "Deep Red" },
    { value: "#2d3436", label: "Graphite" },
  ]
};